const setUpAutocomplete = (el, binding, vnode) => {
  Donut.Autocomplete.setUpAutocomplete(el, binding.value);
};

export default {
  componentUpdated(el, binding, vnode) {
    setUpAutocomplete(el, binding, vnode);
  },
};
